import { settingsEditFieldPermissions, settingsPermissions } from "@/hooks/use-permissions.hook.ts";
import { Home } from "@/pages/home/Home.tsx";
import NotFound from "@/pages/NotFound.tsx";
import { OAuthAuthorize } from "@/pages/oauth/OAuthAuthorize.tsx";
import { PreboardingRoute } from "@/pages/preboarding/PreboardingRoute.tsx";
import EmailConfirmed from "@/pages/security/EmailConfirmed.tsx";
import { accountSettingsRoutes } from "@/routes/configs/modules/account-settings.routes.tsx";
import { blogRoutes } from "@/routes/configs/modules/blog.routes.tsx";
import { calendarRoutes } from "@/routes/configs/modules/calendar.routes.tsx";
import { docsRoutes } from "@/routes/configs/modules/docs.routes.tsx";
import { employeeRoutes } from "@/routes/configs/modules/employee.routes.tsx";
import { esignRoutes } from "@/routes/configs/modules/esign.routes.tsx";
import { feedbackRoutes } from "@/routes/configs/modules/feedback.routes.tsx";
import { helpRoutes } from "@/routes/configs/modules/help.routes.tsx";
import { printRoutes } from "@/routes/configs/modules/print.routes.tsx";
import { recruitmentRoutes } from "@/routes/configs/modules/recruitment.routes.tsx";
import { reportsRoutes } from "@/routes/configs/modules/reports.routes.tsx";
import { settingsRoutes } from "@/routes/configs/modules/settings.routes.tsx";
import { talentRoutes } from "@/routes/configs/modules/talent.routes.tsx";
import { tasksRoutes } from "@/routes/configs/modules/tasks.routes.tsx";
import { timeOffRoutes } from "@/routes/configs/modules/time-off.routes.tsx";
import { workflowRoutes } from "@/routes/configs/modules/workflow.routes.tsx";
import { RouteConfig } from "@/routes/types/route.types.ts";

export const authenticatedRoutes: RouteConfig[] = [
  { path: "/", redirect: "/home" },
  { path: "/home", element: <Home />, isHideSidebar: true },
  { path: "/preboarding", element: <PreboardingRoute />, isFullScreen: true },
  ...recruitmentRoutes,
  {
    path: "/settings",
    children: settingsRoutes,
    anyOfPermissions: settingsPermissions,
    anyOfEditFieldPermissions: settingsEditFieldPermissions,
  },
  ...employeeRoutes,
  ...esignRoutes,
  ...docsRoutes,
  ...reportsRoutes,
  ...calendarRoutes,
  ...timeOffRoutes,
  ...blogRoutes,
  ...accountSettingsRoutes,
  ...feedbackRoutes,
  ...helpRoutes,
  ...printRoutes,
  ...talentRoutes,
  ...workflowRoutes,
  ...tasksRoutes,
  {
    path: "/oauth/authorize",
    element: <OAuthAuthorize />,
    isHideSidebar: true,
    isFullScreen: true,
  },
  { path: "email-confirmed", element: <EmailConfirmed /> },
  { path: "*", element: <NotFound /> },
];
